import { ref } from 'vue';
import ApiService from '@/services/api.service';
import AlertService from '@/services/errors.service';

const isOpenPlanPriceDialog = ref(false);
const plans = ref([]);
const tenantInfo = ref();
let currentPlan = ref();
let allFeatures = ref([]);
let countSummary = ref();
// Hint this approach  was used before integrate to stripe
let hasPendingRequest = ref();
let subscriptionRemainingDays = ref();
let hasActiveSubscription = ref(false);
export default function usePlanPrice() {
  const setPlanPriceDialog = async (newVal) => {
    isOpenPlanPriceDialog.value = newVal;
  };
  const fetchPlans = async () => {
    return new Promise((resolve, reject) => {
      ApiService.get('/api-plan') // Example API endpoint
        .then((response) => {
          plans.value = response.data; // Set the plans ref to the response
          currentPlan.value = response?.data?.plans?.filter((obj) => obj?.current_plan)[0] ?? null;
          allFeatures.value = response?.data?.features ?? [];
          countSummary.value = response?.data?.count_summary ?? null;
          // hasPendingRequest.value = response?.data?.has_pending_request ?? false;
          hasActiveSubscription.value = response?.data?.has_active_subscription ?? false;
          subscriptionRemainingDays.value = response?.data?.remaining_days;

          resolve(response.data); // Resolve the promise with the response data
        })
        .catch((error) => {
          reject(error); // Reject the promise if there's an error
        });
    });
  };
  const fetchTenantInfoPlans = async () => {
    return new Promise((resolve, reject) => {
      ApiService.get('/tenant') // Example API endpoint
        .then((response) => {
          tenantInfo.value = response.data.data; // Set the plans ref to the response

          resolve(response.data); // Resolve the promise with the response data
        })
        .catch((error) => {
          reject(error); // Reject the promise if there's an error
        });
    });
  };
  const subscribePlan = async (payload) => {
    return new Promise((resolve, reject) => {
      ApiService.post('/payment/stripe/checkout-session', payload) // Example API endpoint
        .then((response) => {
          resolve(response.data); // Resolve the promise with the response data
        })
        .catch((error) => {
          AlertService.errorMessage(error.response.data.message);
          reject(error); // Reject the promise if there's an error
        });
    });
  };
  return {
    subscribePlan,
    fetchTenantInfoPlans,
    setPlanPriceDialog,
    tenantInfo,
    currentPlan,
    allFeatures,
    isOpenPlanPriceDialog,
    fetchPlans,
    subscriptionRemainingDays,
    countSummary,
    hasActiveSubscription,
    hasPendingRequest,
    plans
  };
}
